var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTourtaxi = function SvgIconTourtaxi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 104,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__a)",
    fillOpacity: 0.8,
    d: "M59.143 71.714c32.664 0 59.143 1.343 59.143 3s-26.48 3-59.143 3c-32.664 0-59.143-1.343-59.143-3s26.48-3 59.143-3",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-tourtaxi_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24262C",
    d: "M33.747 70.096H30.23c-.816 4.25-4.424 6.571-6.125 6.719 8.167.443 9.302-4.948 9.642-6.719M76.173 70.096H73.62c-.816 4.958-4.906 6.578-6.607 6.75 8.167.516 8.82-4.684 9.16-6.75M58.817 70.096h-2.269c-.726 4.25-3.932 5.607-5.445 5.755 7.26.442 7.411-3.984 7.714-5.755M103.171 69.132h-2.552c-.817 4.958-4.424 6.541-6.126 6.713 8.167.517 8.338-4.647 8.678-6.713"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M102.207 69.132c0 3.723-3.848 6.75-7.28 6.75s-6.22-3.017-6.22-6.75 2.788-6.75 6.22-6.75 7.28 3.016 7.28 6.75M56.888 69.614c0 3.457-2.592 6.268-5.785 6.268s-5.785-2.801-5.785-6.268 2.593-6.267 5.785-6.267 5.785 2.8 5.785 6.267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__c)",
    d: "M103.956 56.082c-4.406-4.88-12.308-7.862-14.925-9.468-2.627-1.597-10.215-10.357-24.352-10.357-4.496 0-15.924.242-24.534.242-6.103 0-10.791 1.02-14.419 2.415-2.405.92-4.335 2-5.91 3.062 3.849-1.354 8.8-2.466 14.358-2.324 11.57.283 18.764 6.7 18.764 6.7l4.9 6.709s8.387 1.384 14.986 4.86c4.395 2.314 5.517 9.043 5.8 12.337 15.53-.02 26.605-.202 27.383-.707 2.243-1.455.455-10.67-2.051-13.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__d)",
    fillOpacity: 0.2,
    d: "M103.956 56.082c-4.406-4.88-12.308-7.862-14.925-9.468-2.627-1.597-10.215-10.357-24.352-10.357-4.496 0-15.924.242-24.534.242-6.103 0-10.791 1.02-14.419 2.415-2.405.92-4.335 2-5.91 3.062 3.849-1.354 8.8-2.466 14.358-2.324 11.57.283 18.764 6.7 18.764 6.7l4.9 6.709s8.387 1.384 14.986 4.86c4.395 2.314 5.517 9.043 5.8 12.337 15.53-.02 26.605-.202 27.383-.707 2.243-1.455.455-10.67-2.051-13.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__e)",
    fillOpacity: 0.2,
    d: "M103.956 56.082c-4.406-4.88-12.308-7.862-14.925-9.468-2.627-1.597-10.215-10.357-24.352-10.357-4.496 0-15.924.242-24.534.242-6.103 0-10.791 1.02-14.419 2.415-2.405.92-4.335 2-5.91 3.062 3.849-1.354 8.8-2.466 14.358-2.324 11.57.283 18.764 6.7 18.764 6.7l4.9 6.709s8.387 1.384 14.986 4.86c4.395 2.314 5.517 9.043 5.8 12.337 15.53-.02 26.605-.202 27.383-.707 2.243-1.455.455-10.67-2.051-13.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__f)",
    d: "M72.814 57.921c-6.599-3.476-14.985-4.86-14.985-4.86l-4.901-6.71s-7.195-6.416-18.764-6.699c-5.558-.131-10.51.97-14.359 2.324a32 32 0 0 0-2.809 2.122c-2.799 2.324-2.81 5.325-3.183 9.256-.111 1.121-.727 5.082-2.061 8.003-.495 1.08.121 3.627.656 4.86.769 1.748 2.87 3.627 4.588 3.627 13.116 0 40.044.435 61.618.405-.283-3.294-1.405-10.024-5.8-12.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__g)",
    fillOpacity: 0.3,
    d: "M72.814 57.921c-6.599-3.476-14.985-4.86-14.985-4.86l-4.901-6.71s-7.195-6.416-18.764-6.699c-5.558-.131-10.51.97-14.359 2.324a32 32 0 0 0-2.809 2.122c-2.799 2.324-2.81 5.325-3.183 9.256-.111 1.121-.727 5.082-2.061 8.003-.495 1.08.121 3.627.656 4.86.769 1.748 2.87 3.627 4.588 3.627 13.116 0 40.044.435 61.618.405-.283-3.294-1.405-10.024-5.8-12.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__h)",
    fillOpacity: 0.2,
    d: "M72.814 57.921c-6.599-3.476-14.985-4.86-14.985-4.86l-4.901-6.71s-7.195-6.416-18.764-6.699c-5.558-.131-10.51.97-14.359 2.324a32 32 0 0 0-2.809 2.122c-2.799 2.324-2.81 5.325-3.183 9.256-.111 1.121-.727 5.082-2.061 8.003-.495 1.08.121 3.627.656 4.86.769 1.748 2.87 3.627 4.588 3.627 13.116 0 40.044.435 61.618.405-.283-3.294-1.405-10.024-5.8-12.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__i)",
    d: "M11.57 63.044s0 3.496 1.405 5.164c1.404 1.667 1.687 2.405 4.355 2.405h86.424c1.829 0 3.163-1.577 3.213-3.264h-91.88s-2.254-2.506-3.517-4.305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__j)",
    d: "M31.314 70.33c0 3.617-2.839 6.558-6.335 6.558s-6.336-2.93-6.336-6.558 2.84-6.558 6.336-6.558 6.335 2.93 6.335 6.558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__k)",
    d: "M24.979 74.593a4.264 4.264 0 1 0 0-8.528 4.264 4.264 0 0 0 0 8.528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__l)",
    stroke: "url(#icon-tourtaxi_svg__m)",
    strokeWidth: 0.103,
    d: "M23.909 70.33c0-.588.482-1.07 1.07-1.07s1.07.481 1.07 1.07c0 .587-.482 1.07-1.07 1.07s-1.07-.483-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__n)",
    d: "M73.754 70.33c0 3.617-2.84 6.558-6.336 6.558s-6.336-2.93-6.336-6.558 2.84-6.558 6.336-6.558 6.336 2.93 6.336 6.558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__o)",
    d: "M67.418 74.593a4.264 4.264 0 1 0 0-8.528 4.264 4.264 0 0 0 0 8.528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__p)",
    stroke: "url(#icon-tourtaxi_svg__q)",
    strokeWidth: 0.103,
    d: "M66.348 70.33c0-.588.482-1.07 1.07-1.07s1.07.481 1.07 1.07c0 .587-.482 1.07-1.07 1.07s-1.07-.483-1.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__r)",
    d: "m14.238 48.665 3.284-2.98.879 2.06-4.588 5.609z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__s)",
    d: "M102.754 60.963h3.486s-.495-4.416-2.294-4.88c-1.091.929-1.202 4.88-1.202 4.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__t)",
    d: "M100.531 62.64H88.638c-.566 0-.809 0-1.082 1-.232.84-.838 3.385-.838 3.385a1.09 1.09 0 0 0 1.081 1.183h13.762c.728 0 1.253-.708 1.041-1.415l-1.03-3.385a1.095 1.095 0 0 0-1.041-.768"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__u)",
    d: "M99.823 64.085h-9.74V66.5h9.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__v)",
    d: "M68.398 56.082s1.04 4.254 4.981 4.688c3.931.435 9.135 0 9.135 0s-.404-3.183-4.072-4.031c-3.668-.85-10.034-.657-10.034-.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__w)",
    fillOpacity: 0.2,
    d: "M68.398 56.082s1.04 4.254 4.981 4.688c3.931.435 9.135 0 9.135 0s-.404-3.183-4.072-4.031c-3.668-.85-10.034-.657-10.034-.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__x)",
    d: "M50.715 43.673a27 27 0 0 0-1.637-1.717c-2.789-2.567-6.214-3.537-17.46-1.98-5.74.797-9.812 4.88-9.812 4.88l.819 1.485 1.626 2.97 30.97.435s-1.12-2.273-4.496-6.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__y)",
    d: "M87.565 44.343c-3.032-2.021-6.063-4.042-9.094-5.052-8.62-.233-26.403.434-26.403.434l2.06 2.546 5.81 7.195 28.758-.233 5.797.133c-1.404-1.455-4.725-3.487-6.928-5.023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__z)",
    fillOpacity: 0.2,
    d: "M87.565 44.343c-3.032-2.021-6.063-4.042-9.094-5.052-8.62-.233-26.403.434-26.403.434l2.06 2.546 5.81 7.195 28.758-.233 5.797.133c-1.404-1.455-4.725-3.487-6.928-5.023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__A)",
    fillOpacity: 0.2,
    d: "M87.565 44.343c-3.032-2.021-6.063-4.042-9.094-5.052-8.62-.233-26.403.434-26.403.434l2.06 2.546 5.81 7.195 28.758-.233 5.797.133c-1.404-1.455-4.725-3.487-6.928-5.023"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourtaxi_svg__B)",
    d: "M44.95 36.59s.65-1.652 1.002-2.674c.35-1.034 1.238-1.45 3.081-1.477l7.242-.1c1.727-.025 2.438.578 2.83 1.467a32 32 0 0 1 .988 2.572l-15.128.212z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#33B9E8",
    d: "M28.891 53.858h-2.086v2.074h2.086zM30.978 55.932H28.89v2.075h2.087zM26.793 55.932h-2.087v2.075h2.087zM33.064 53.858h-2.086v2.074h2.086zM35.163 55.932h-2.087v2.075h2.087zM37.25 53.858h-2.087v2.074h2.087zM39.337 55.932H37.25v2.075h2.087zM41.423 53.858h-2.087v2.074h2.087zM45.608 53.858h-2.087v2.074h2.087zM43.522 55.932h-2.087v2.075h2.087zM47.694 55.932h-2.086v2.075h2.086z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__c",
    x1: 60.072,
    x2: 95.438,
    y1: 53.444,
    y2: 49.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F7F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F6F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__d",
    x1: 102.511,
    x2: 91.396,
    y1: 66.58,
    y2: 56.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#C7C9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E7EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__e",
    x1: 78.26,
    x2: 80.281,
    y1: 66.075,
    y2: 63.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__f",
    x1: 41.59,
    x2: 39.414,
    y1: 42.676,
    y2: 69.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#EDEDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#C8C9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__g",
    x1: 72.197,
    x2: 86.849,
    y1: 59.507,
    y2: 73.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E4EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__h",
    x1: 58.051,
    x2: 53.294,
    y1: 44.847,
    y2: 56.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__i",
    x1: 109.079,
    x2: 34.81,
    y1: 63.044,
    y2: 69.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E9EAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#F4F4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#C4C5CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C7D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__j",
    x1: 24.979,
    x2: 24.979,
    y1: 63.772,
    y2: 76.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__k",
    x1: 24.979,
    x2: 24.979,
    y1: 66.065,
    y2: 74.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#AAACBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__l",
    x1: 24.979,
    x2: 24.979,
    y1: 71.451,
    y2: 69.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAACBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__m",
    x1: 24.979,
    x2: 24.979,
    y1: 71.451,
    y2: 69.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__n",
    x1: 67.418,
    x2: 67.418,
    y1: 63.772,
    y2: 76.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__o",
    x1: 67.418,
    x2: 67.418,
    y1: 66.065,
    y2: 74.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#AAACBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__p",
    x1: 67.418,
    x2: 67.418,
    y1: 71.451,
    y2: 69.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAACBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__q",
    x1: 67.418,
    x2: 67.418,
    y1: 71.451,
    y2: 69.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__r",
    x1: 17.358,
    x2: 13.161,
    y1: 33.222,
    y2: 51.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__s",
    x1: 104.492,
    x2: 104.674,
    y1: 61.034,
    y2: 56.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__t",
    x1: 94.682,
    x2: 94.682,
    y1: 62.64,
    y2: 68.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__u",
    x1: 94.953,
    x2: 94.953,
    y1: 64.085,
    y2: 66.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__v",
    x1: 75.36,
    x2: 75.532,
    y1: 60.922,
    y2: 56.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__w",
    x1: 62.598,
    x2: 73.713,
    y1: 64.559,
    y2: 56.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__x",
    x1: 42.907,
    x2: 24.105,
    y1: 45.509,
    y2: 45.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__y",
    x1: 57.251,
    x2: 74.429,
    y1: 47.879,
    y2: 19.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585A69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#858698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#A1A3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#C0C3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#C0C3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#BDBECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__z",
    x1: 83.018,
    x2: 77.965,
    y1: 39.796,
    y2: 45.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__A",
    x1: 72.441,
    x2: 70.513,
    y1: 49.791,
    y2: 38.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747685",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourtaxi_svg__B",
    x1: 55.726,
    x2: 48.706,
    y1: 33.872,
    y2: 34.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#32B9E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-tourtaxi_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(58.9569 0 0 2.99203 59.038 75.096)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-tourtaxi_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.57 36.267h95.458v40.66H11.57z"
  })))));
};
export default SvgIconTourtaxi;